export enum UserRoleEnum {
  Supervisor = 1,
  Manager,
  Worker,
}
